import { createSelector } from 'reselect';
export const selectContactForm = (state) => state.contactForm;
export const selectContactFormError = createSelector(selectContactForm, (state) => state.error);
export const selectContactFormLoading = createSelector(selectContactForm, (state) => state.isLoading);
export const selectContactFormResponse = createSelector(selectContactForm, (state) => state.result);
